import {getAccessToken} from '@/utils/auth'
import { CACHE_KEY, useCache } from '@/store/web/useCache'
import { HttpManager } from "@/api";

const { wsCache } = useCache()

export default {
  state: {
    userId: "", // ID
    username: "", // 名字
    userPic: "", // 图片
    accessToken: "", // token
    refreshToken: "", // token
    userInfo: null, // 单个用户信息
    myInfo: null, // 我的信息
    myDetailInfo: null, // 我的详细信息
  },
  getters: {
    userId: (state) => state.userId,
    username: (state) => state.username,
    userPic: (state) => state.userPic,
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
    userInfo: (state) => state.userInfo,
    myInfo: (state) => state.myInfo,
    myDetailInfo: (state) => state.myDetailInfo,
  },
  mutations: {
    setUserId: (state, userId) => {
      state.userId = userId;
    },
    setUsername: (state, username) => {
      state.username = username;
    },
    setUserPic: (state, userPic) => {
      state.userPic = userPic;
    },
    setAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    setRefreshToken: (state, refreshToken) => {
      state.refreshToken = refreshToken;
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    setMyInfo: (state, myInfo) => {
      state.myInfo = myInfo;
    },
    setMyDetailInfo: (state, myDetailInfo) => {
      state.myDetailInfo = myDetailInfo;
    },
  },
  actions: {
    async setUserInfoAction({ commit }) {
      if (!getAccessToken()) {
        commit('setMyInfo',null)
        return null
      }
      let userInfo = wsCache.get(CACHE_KEY.USER)
      if (!userInfo) {
        const result = (await HttpManager.getInfo()) as ResponseBody;
        userInfo = result.data
      } else {
        // 特殊：在有缓存的情况下，进行加载。但是即使加载失败，也不影响后续的操作，保证可以进入系统
        try {
          const result = (await HttpManager.getInfo()) as ResponseBody;
          userInfo = result.data
        } catch (error) {console.log(error)}
      }
      commit("setMyInfo", userInfo);
      wsCache.set(CACHE_KEY.USER, userInfo)
    }
  }
};
